import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueTheMask from 'vue-the-mask'
import router from './router/index'
import '@fortawesome/fontawesome-free/css/all.css'
import './registerServiceWorker'
import { formatDate, formatNumber } from './helpers'


loadFonts()

const app = createApp(App);

app.config.globalProperties.$formatNumber = formatNumber;
app.config.globalProperties.$formatDate = formatDate;

app
  .use(vuetify)
  .use(VueTheMask)
  .use(router)
  .mount('#app');